import { useContext } from 'react'

import { Error, Row, Spacer, Footer, VSpacer } from 'components/ui/form/Form'
import { ModalContext } from 'context/ModalContext'
import { Button, InputFormik } from 'components/gsys-ui'
import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline'

const UserForm = ({ isSubmitting, handleSubmit, error }) => {
  const modal = useContext(ModalContext)

  return (
    <>
      <Row>
        Email and password are optional. Using only a name will allow log in to the scanners only. Adding an email and password will allow log in to the web control panel.
      </Row>
      <Error>{error}</Error>
      <Row>
        <InputFormik name="name" label="Name" />
        <InputFormik name="email" label="Email (optional)" />
      </Row>
      <Row>
        <InputFormik type="password" name="password" label="Password (optional)" />
        <VSpacer />
      </Row>
      <Spacer />
      <Footer>
        <Button variant="white" onClick={modal.close}>
          <XMarkIcon className="mr-1 w-5 h-5" />
          Cancel
        </Button>
        <Button variant="green" onClick={handleSubmit} loading={isSubmitting}>
          <CheckIcon className="mr-1 w-5 h-5" />
          Submit
        </Button>
      </Footer>
    </>
  )
}

export default UserForm